/* eslint-disable react/react-in-jsx-scope */
import { PageBlueprint, createFrontendPlugin } from '@backstage/frontend-plugin-api';
import MemoryIcon from '@material-ui/icons/Memory';
import ExtensionIcon from '@material-ui/icons/Extension';
import { agentsRouteRef, skillsRouteRef } from './routes';

const agentsPage = PageBlueprint.make({
  name: 'page:rithum-ai/agents', // nav.take('page:rithum-ai/page:rithum-ai/agents') to add to nav sidebar
  params: {
    path: '/rithum-ai/agents',
    routeRef: agentsRouteRef,
    // Empty title hides the NFS PageLayout chrome (icon+text size mismatch vs MUI icons).
    // The real header is Backstage <Header> inside AgentExplorerPage (matches Docs).
    title: 'Agents',
    icon: <MemoryIcon fontSize="inherit" viewBox='0 0 24 24' />, // make the icon and font size match the text size that is default in other backstage plugins
    loader: () =>
      import('./components/AgentExplorerPage/AgentExplorerPage').then(m => (
        <m.AgentExplorerPage />
      )),
  },
});

const skillsPage = PageBlueprint.make({
  name: 'page:rithum-ai/skills', // nav.take('page:rithum-ai/page:rithum-ai/skills') to add to nav sidebar
  params: {
    path: '/rithum-ai/skills',
    routeRef: skillsRouteRef,
    title: 'Skills',
    icon: <ExtensionIcon fontSize="inherit" viewBox='0 0 24 24' />, // make the icon and font size match the text size that is default in other backstage plugins
    loader: () =>
      import('./components/SkillExplorerPage/SkillExplorerPage').then(m => (
        <m.SkillExplorerPage />
      )),
  },
});

export const rithumAiPlugin = createFrontendPlugin({
  pluginId: 'rithum-ai',
  extensions: [agentsPage, skillsPage],
  routes: {
    agents: agentsRouteRef,
    skills: skillsRouteRef,
  },
});
